import { render, staticRenderFns } from "./PushMessageDialog.vue?vue&type=template&id=e9255fcc&scoped=true"
import script from "./PushMessageDialog.vue?vue&type=script&lang=js"
export * from "./PushMessageDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9255fcc",
  null
  
)

export default component.exports